
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarTargetTrackedSelectedIec as ObiRadarTargetTrackedSelectedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-target-tracked-selected-iec.js';
 
 
 

 
 export const ObiRadarTargetTrackedSelectedIec = createComponent({
   react: React,
   tagName: 'obi-radar-target-tracked-selected-iec',
   elementClass: ObiRadarTargetTrackedSelectedIecElement,
   events: {
     
   }
  });
 
 